/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import React, { FunctionComponent } from 'react';

import PropTypes from 'prop-types';

import { RootState, useTivoSelector } from '../../../../../core/tivo/tivo-redux-wrapper';
import { ImageLoader } from '../../../../ImageLoader';
import { ImageLoaderTypes } from '../../../../ImageLoader/ImageLoaderTypes';
import { ButtonProps } from './ButtonProps';

import './Button.scss';

const Button: FunctionComponent<ButtonProps> = (props): JSX.Element => {
    const { text, isFocused, displayValue, isLargeSizeButton }: ButtonProps = props;
    const { isOverlayGhostHighlightActive } = useTivoSelector(
        (state: RootState) => state.overlayHighlight,
    );

    let optionButtonClasses = 'options-button ';
    if (props.isLargeSizeButton) {
        optionButtonClasses += 'large-size-options-button ';
    }
    if (isOverlayGhostHighlightActive && isFocused) {
        optionButtonClasses += ' highlight-stroke ghost-overlay';
    } else if (isFocused) {
        optionButtonClasses += ' highlight-stroke';
    }

    const formatTextForLargeButtons = (textTobeFormatted: string) => {
        const parts = textTobeFormatted.split('#');
        return parts;
    };
    let textInParts: string[] = [];
    if (isLargeSizeButton) textInParts = formatTextForLargeButtons(text);
    return (
        <div className={optionButtonClasses}>
            {isLargeSizeButton ? (
                <>{textInParts?.map((part, index) => <span key={index}>{part}</span>)}</>
            ) : (
                <>{text}</>
            )}
            {/* TODO: handle displayValue of type text, currently no usecase */}
            {displayValue?.type === 'image' && displayValue.value?.length ? (
                <div className="options-button-icons">
                    {displayValue.value.map((src, index) => (
                        <ImageLoader
                            src={src}
                            key={index}
                            imageType={ImageLoaderTypes.OPTION_BUTTON_ICON}
                        />
                    ))}
                </div>
            ) : null}
        </div>
    );
};

Button.propTypes = {
    id: PropTypes.number,
    text: PropTypes.string.isRequired,
    isFocused: PropTypes.bool.isRequired,
    isSelectOptionButton: PropTypes.bool,
    displayValue: PropTypes.any,
};
export default Button;
